import {ThemePreference, useTheme} from '../../contexts/ThemeContext'

const OPTIONS: Array<{id: ThemePreference; label: string}> = [
  {id: 'light', label: 'Light'},
  {id: 'dark', label: 'Dark'},
  {id: 'system', label: 'System'},
]

export default function ThemeToggle() {
  const {preference, setPreference} = useTheme()

  return (
    <div className="inline-flex rounded-md border border-sky-300/70 dark:border-slate-600 overflow-hidden">
      {OPTIONS.map((option) => {
        const isActive = preference === option.id
        return (
          <button
            key={option.id}
            type="button"
            className={[
              'px-2 py-1 text-xs font-semibold transition-colors',
              'focus:outline-none focus:ring-2 focus:ring-sky-200 dark:focus:ring-sky-500',
              isActive
                ? 'bg-white text-sky-700 dark:bg-slate-800 dark:text-slate-100'
                : 'bg-sky-600 text-sky-100 hover:bg-sky-500 dark:bg-slate-700 dark:text-slate-200 dark:hover:bg-slate-600',
            ].join(' ')}
            onClick={() => setPreference(option.id)}
            aria-pressed={isActive}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
